import React, { useEffect, useState } from 'react'
import { Autocomplete, TextField } from '@mui/material'
import services from '../../services'

export interface PessoaAchada { id: number; nome: string; email: string; empresa?: string | null }

/** Escolhe uma pessoa buscando no servidor por nome, e-mail, login ou empresa. */
export default function BuscaPessoa({ valor, aoEscolher, rotulo = 'Pessoa' }: {
  valor: PessoaAchada | null
  aoEscolher: (p: PessoaAchada | null) => void
  rotulo?: string
}) {
  const [texto, setTexto] = useState('')
  const [opcoes, setOpcoes] = useState<PessoaAchada[]>([])
  const [carregando, setCarregando] = useState(false)

  useEffect(() => {
    const termo = texto.trim()
    if (termo.length < 2 || (valor && termo === valor.nome)) { setOpcoes(valor ? [valor] : []); return }
    setCarregando(true)
    const t = setTimeout(async () => {
      const r = await services.api.novoPortalPessoas({ busca: termo, tamanho: 20 })
      setCarregando(false)
      setOpcoes(r.fail ? [] : (r.data?.pessoas || []).map((p: any) => ({ id: p.id, nome: p.nome, email: p.email, empresa: p.empresa })))
    }, 300)
    return () => clearTimeout(t)
  }, [texto, valor])

  return (
    <Autocomplete
      size="small"
      options={opcoes}
      value={valor}
      filterOptions={x => x}
      loading={carregando}
      getOptionLabel={p => p.nome}
      isOptionEqualToValue={(a, b) => a.id === b.id}
      onChange={(_, p) => aoEscolher(p)}
      onInputChange={(_, t) => setTexto(t)}
      noOptionsText={texto.trim().length < 2 ? 'Digite ao menos 2 letras' : 'Ninguém com esse nome'}
      loadingText="Buscando…"
      renderOption={(props, p) => (
        <li {...props} key={p.id}>
          <span><b>{p.nome}</b><small style={{ display: 'block', color: '#8b92a1' }}>{[p.email, p.empresa].filter(Boolean).join(' · ')}</small></span>
        </li>
      )}
      renderInput={p => <TextField {...p} placeholder="Nome, e-mail ou empresa" aria-label={rotulo} />}
    />
  )
}
